export default __webpack_public_path__ + "static/media/Group 10684.b65270a1.svg";